

/**
 * @fileoverview Connect an explicitly supplied measurement callback to optional browser-performance collection. The caller owns the sink and interpretation; no measurements are delivered without that callback. Performance samples are separate from operational audit, business outcomes, or error reports.
 */

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(

    ({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onINP(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
